import { render, staticRenderFns } from "./patientDetailCard.vue?vue&type=template&id=51465eca&scoped=true&"
import script from "./patientDetailCard.vue?vue&type=script&lang=ts&"
export * from "./patientDetailCard.vue?vue&type=script&lang=ts&"
import style0 from "./patientDetailCard.vue?vue&type=style&index=0&id=51465eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51465eca",
  null
  
)

export default component.exports